import React from 'react'

export default function Icon(props) {
    let media = props.media;
    return (
        media['icon'] && media['icon']['path'] ?
            <div className="icon image contain">
                <img src={media['icon']['path']} alt={media['icon']['alt']} title={media['icon']['title']} />
            </div>
        : null
    )
}
